import { ThunkType } from "../../../../core/store/reducers";
import { getOrderListReportExcel } from "../api/getOrderListReportExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../ordersReportDataSlice"

export const downloadOrdersReportExcel = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const { filter } = store.ux.reports.ordersReport;
	const user = store.data.auth.current.user;
	dispatch(setFetchState({ type: "started"}))
	const ordersReport = await dispatch(getOrderListReportExcel(user, filter));
	if (ordersReport) {
		fileDownload(new Blob([ordersReport as any], { type: "application/vnd.openxmlformat" }), "OrderBook.xlsx");
	}
	dispatch(setFetchState({ type: "not-started"}))
};
